import { useEffect, useState } from "react";
import { userApi } from "../lib/api";

export function PaymentSuccess() {
  const [state, setState] = useState({ status: "checking", kind: "" });
  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await userApi.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState({ status: "paid", kind: data.kind }); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState({ status: "failed", kind: data.kind }); return; }
      } catch {}
      if (tries++ < 12) setTimeout(poll, 2000);
      else setState({ status: "timeout", kind: "" });
    };
    if (sid) poll(); else setState({ status: "failed" });
  }, []);

  return (
    <div className="min-h-screen bg-[#080808] flex items-center justify-center px-7 text-center">
      <div>
        {state.status === "checking" && <p className="text-[#888] tracking-widest uppercase text-xs">Confirmation du paiement...</p>}
        {state.status === "paid" && (
          <div data-testid="payment-success">
            <div className="eff-eyebrow mb-4">Paiement confirmé</div>
            <h1 className="font-display text-4xl md:text-5xl mb-6">Merci.</h1>
            <p className="text-[#aaa] mb-8">{state.kind === "subscription" ? "Votre abonnement est actif." : "Votre billet a été généré et envoyé par email."}</p>
            <a href="/access" className="eff-btn eff-btn-light">Voir mon espace</a>
          </div>
        )}
        {["failed", "timeout"].includes(state.status) && (
          <div data-testid="payment-pending">
            <h1 className="font-display text-3xl mb-4">Paiement en cours de traitement</h1>
            <p className="text-[#aaa] mb-8">Si le montant a été débité, votre commande apparaîtra dans votre espace.</p>
            <a href="/access" className="eff-btn">Mon espace</a>
          </div>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#080808] flex items-center justify-center px-7 text-center" data-testid="payment-cancel">
      <div>
        <h1 className="font-display text-4xl mb-4">Paiement annulé</h1>
        <p className="text-[#aaa] mb-8">Aucun montant n'a été débité.</p>
        <a href="/" className="eff-btn">Retour au site</a>
      </div>
    </div>
  );
}
